import { formatDatetime } from 'helpers/timezone';
import ReminderCard from 'components/cards/reminder';

const CustomerReminders = ({ reminders }) => {
  return (
    <div style={{ padding: '32px 24px', background: 'white' }}>
      <section
        style={{ backgroundColor: 'white', gap: '32px' }}
        className="flex flex-column"
      >
        <div className="flex flex-column">
          {reminders?.map((r) => (
            <ReminderCard
              key={r.id}
              data={r}
              date={formatDatetime(r.reminderDate)}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default CustomerReminders;
